import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { Dialog } from 'components';
import Panel from 'components/atoms/GefMui/Panel/Panel';
import PaperWithToolbar from 'components/atoms/GefMui/PaperWithToolbar';
import MODALS from 'constants/modals';
import PAGES from 'constants/pages';
import { subheaders } from 'features/common/Subheader/constants';
import { useRenderSubheaderTitle } from 'features/common/Subheader/hooks';
import { resetFormCriteria } from 'features/views/roboAdvisory/actions';
import { dialogs } from 'features/views/roboAdvisory/constants';
import { getContextUser } from 'features/views/userContext/selectors';

import RAHandoverModal from './components/modals/RAHandoverModal';
import Filter from './components/RAFilter';
import Table from './components/RATable';
import Toolbar from './components/Toolbar';

const RoboAdvisory = () => {
	const dispatch = useDispatch();

	useEffect(
		() => () => {
			dispatch(resetFormCriteria());
		},
		[dispatch],
	);

	const contextUser = useSelector(getContextUser);

	const subheaderTitle = useRenderSubheaderTitle({
		contextUser,
		pageTitle: getLabelMessage('roboAdvisory:roboAdvisoryAnalysisOverviewTitle'),
	});

	const floatingDialogs = (
		<Dialog mui name={dialogs.SELECT_AMOUNT_LIMIT_FOR_HANDOVER}>
			{getLabelMessage('roboAdvisory:raSelectAmountLimitForHandover')}
		</Dialog>
	);

	return (
		<Panel screenId={PAGES.roboAdvisory.id} screenName={PAGES.roboAdvisory.name} floatingDialogs={floatingDialogs}>
			<RAHandoverModal id={MODALS.roboAdvisory_handover} />
			<PaperWithToolbar
				subheaderTitle={subheaderTitle}
				subTitle={getLabelMessage('roboAdvisory:roboAdvisoryTableRecords2YearsOldOnly')}
				toggledElement={<Filter />}
				toolbar={<Toolbar />}
				collapsibleProps={{ id: subheaders.roboAdvisory, initiallyOpen: false }}
			>
				<Table />
			</PaperWithToolbar>
		</Panel>
	);
};

export default RoboAdvisory;
